import React,{useState,useEffect} from 'react'
import { Row, Col } from 'antd'
import logo from '@/common/images/logotitle.png'
import moment from 'moment'
import screenfull from 'screenfull'
function TopBox(props, ref) {
    const [date, setDate] = useState('')
    const [weekText, setWeekText] = useState('')
    const [hour, setHour] = useState('')
    const [selectAlertType, setSelectAlertType] = useState('燃气井盖管理')
    // 获取时间
    const topTime = () =>{
        const date = moment().format('YYYY-MM-DD')
        const week = moment().day()
        let weekText = ''
        const hour = moment().format('HH:mm:ss')
        switch (week) {
            case 1:
                weekText = '星期一'
                break
            case 2:
                weekText = '星期二'
                break
            case 3:
                weekText = '星期三'
                break
            case 4:
                weekText = '星期四'
                break
            case 5:
                weekText = '星期五'
                break
            case 6:
                weekText = '星期六'
                break
            case 0:
                weekText = '星期日'
                break
          }
          setDate(date)
          setWeekText(weekText)
          setHour(hour)
    }
    // 时间预处理
    const isTopTime = () => {
        if (date&&weekText&&hour) {
            return (
                <div>
                    <span>{date}&nbsp;&nbsp;</span>
                    <span>{weekText}&nbsp;&nbsp;</span>
                    <span>{hour}&nbsp;&nbsp;</span>
                </div>
            )
        } else {
            return (
                <div>
                    <span>时间加载中...</span>
                </div>
            )
        }
    }
    // 点击查看设备汇总modal框
    const openDeviceSummaryModal = () => {
        props.subClick('popup', 'filterbg')
    }
    // 点击进入控制台
    const goToSystem = () => {
        props.history.push('/home1')
    }
    const initSelectType = () => {
        return <h3>{selectAlertType}</h3>
    }
    // 切换总汇类型数据
    const openSummeryType = (type) => {
        switch (type) {
            // case '总汇':
            //     setSelectAlertType('总汇')
            //     props.openAlertType('summary')
            //     break;
            case '燃气井盖管理':
                setSelectAlertType('燃气井盖管理')
                props.openAlertType('classification')
                break;
            case '通信井盖管理':
                setSelectAlertType('通信井盖管理')
                props.openAlertType('communication')
                break;
            case '水务井盖管理':
                setSelectAlertType('水务井盖管理')
                props.openAlertType('waterAffairs')
                break;
            default:
                break;
        }
        initSelectType()
    }
    useEffect(() => {
        setTimeout(() => {
            topTime()
        }, 1000);
    }, [hour])
    return (
        <div id="top">
            <div className="wp">
                <Row className="row_box" gutter={24}>
                    <Col span={6}>
                        <div className="left pageTit" onClick={()=>openDeviceSummaryModal()}>物联网智能设备汇总</div>
                    </Col>
                    <Col span={12}>
                        <div className="center topLogo">
                            <img src={logo}/>
                        </div>
                    </Col>
                    <Col span={6}>
                        <div className="right topBar">
                            {isTopTime()}
                            <div className="console">
                                <div className="type_switch">
                                    {initSelectType()}
                                    <div className="dropdown">
                                        <a onClick={() => openSummeryType('燃气井盖管理')}>燃气井盖管理</a>
                                        <a onClick={() => openSummeryType('通信井盖管理')}>通信井盖管理</a>
                                        <a onClick={() => openSummeryType('水务井盖管理')}>水务井盖管理</a>
                                        {/* <a onClick={() => openSummeryType('总汇')}>总汇</a> */}
                                    </div>
                                </div>
                                <a className="console_item" onClick={() => screenfull.request()}>全屏</a>
                                <a className="console_item" onClick={goToSystem}>进入控制台</a>
                                {/* <a className="console_item">退出</a> */}
                            </div>
                        </div>
                    </Col>
                </Row>
            </div>
        </div>
    )
}
export default TopBox